import helper from "@/utils/helper";

export default [{
	path: '/login',
	name: 'login',
	component: () => import('@/views/Login'),
	meta: {
		guest: true,
		includeInNavbar: false,
		title: 'Sign In',
		layout: 'empty'
	}
},
{
	path: '/',
	name: 'dashboard',
	component: () => import('@/views/Dashboard'),
	meta: {
		requiresAuth: true,
		includeInNavbar: true,
		title: 'Dashboard',
		icon: 'fa-solid fa-table-columns'
	}
},
{
	path: '/',
	name: 'landing',
	redirect: {
		name: 'dashboard'
	}
},
{
	name: 'cases',
	path: '/cases',
	component: () => import('@/views/Cases'),
	meta: {
		includeInNavbar: true,
		isGroup: true,
		title: 'NOD Cases',
	},
	children: [{
		path: '/cases/site-visit-list',
		name: 'cases.site-visit-list',
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Site Visit List',
			icon: 'fa-solid fa-clipboard-check',
			badge: [{ name: 'siteVisitCount.new', showFor: helper.jkrRoles }, { name: 'siteVisitCount.submitted', showFor: helper.jkrRoles }]
		}
	}]
}, {
	name: 'work-order',
	path: '/work-order',
	component: () => import('@/views/Cases'),
	meta: {
		includeInNavbar: true,
		isGroup: true,
		title: 'Work Order',
	},
	children: [{
		path: '/work-order/summary',
		name: 'work-order.summary',
		component: () => import('@/views/Dashboard'),
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Summary',
			icon: 'fa-solid fa-chart-pie'
		}
	}, {
		path: '/work-order/bq-list',
		name: 'work-order.bq-list',
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'NOD List',
			icon: 'fa-solid fa-list-check'
		}
	}, {
		path: '/work-order/list',
		name: 'work-order.list',
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Work Order List',
			icon: 'fa-solid fa-list',
			badge: [{ name: 'bqCount.kjp', showFor: helper.jkrRoles }]
		}
	},
	{
		path: '/work-order/completed',
		name: 'work-order.completed',
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Completed',
			icon: 'fa-solid fa-circle-check'
		}
	},
	{
		path: '/work-order/rejected',
		name: 'work-order.rejected',
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Rejected',
			icon: 'fa-solid fa-circle-xmark'
		}
	}]
}, {
	name: 'emergency',
	path: '/emergency',
	component: () => import('@/views/Cases'),
	meta: {
		includeInNavbar: true,
		isGroup: true,
		title: 'Emergency Cases',
	},
	children: [{
		path: '/emergency/summary',
		name: 'emergency.summary',
		component: () => import('@/views/Dashboard'),
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Summary',
			icon: 'fa-solid fa-chart-pie'
		}
	}, {
		path: '/emergency/bq-list',
		name: 'emergency.bq-list',
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Claims',
			icon: 'fa-solid fa-list-check'
		}
	}, {
		path: '/emergency/approved',
		name: 'emergency.approved',
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Approved Claims',
			icon: 'fa-solid fa-square-check',
			badge: [{ name: 'bqCount.emergency', showFor: helper.jkrRoles }]
		}
	}, {
		path: '/emergency/rejected',
		name: 'emergency.rejected',
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Rejected',
			icon: 'fa-solid fa-square-xmark'
		}
	}]
}, {
	name: 'electrical',
	path: '/electrical',
	component: () => import('@/views/Cases'),
	meta: {
		includeInNavbar: true,
		isGroup: true,
		title: 'Electrical Cases',
	},
	children: [{
		path: '/electrical/summary',
		name: 'electrical.summary',
		component: () => import('@/views/Dashboard'),
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Summary',
			icon: 'fa-solid fa-chart-pie'
		}
	}, {
		path: '/electrical/bq-list',
		name: 'electrical.bq-list',
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Claims',
			icon: 'fa-solid fa-list-check'
		}
	}, {
		path: '/electrical/approved',
		name: 'electrical.approved',
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Approved Claims',
			icon: 'fa-solid fa-square-check',
			badge: [{ name: 'bqCount.electrical', showFor: helper.jkrRoles }]
		}
	}, {
		path: '/electrical/rejected',
		name: 'electrical.rejected',
		meta: {
			requiresAuth: true,
			includeInNavbar: true,
			title: 'Rejected',
			icon: 'fa-solid fa-square-xmark',
		}
	}]
}, {
	name: 'pavement',
	path: '/pavement',
	component: () => import('@/views/PavementCases'),
	meta: {
		includeInNavbar: true,
		isGroup: true,
		title: 'Pavement Cases',
		hideFor: helper.jkrRoles,
	},
	children: [
		{
			path: '/pavement/summary',
			name: 'pavement.summary',
			component: () => import('@/views/PavementDashboard'),
			meta: {
				requiresAuth: true,
				includeInNavbar: true,
				title: 'Summary',
				icon: 'fa-solid fa-chart-pie'
			}
		}, {
			path: '/pavement/all',
			name: 'pavement.all',
			meta: {
				requiresAuth: true,
				includeInNavbar: true,
				title: 'All Cases',
				icon: 'fa-solid fa-clipboard-check'
			}
		}
	]
}, {
	path: '/case-details/:id',
	name: 'case-details',
	component: () => import('@/views/CaseDetails'),
	meta: {
		requiresAuth: true,
		includeInNavbar: false,
		hasBackNavigation: true,
		title: 'Case Details',
		icon: 'fa-solid fa-table-columns'
	}
}, {
	path: '/pavement-details/:id',
	name: 'pavement-details',
	component: () => import('@/views/PavementDetails'),
	meta: {
		requiresAuth: true,
		includeInNavbar: false,
		hasBackNavigation: true,
		title: 'Case Details',
		icon: 'fa-solid fa-table-columns'
	}
}, {
	path: '/manage/budgets',
	name: 'manage.budgets',
	component: () => import('@/views/Manage/Budgets'),
	meta: {
		requiresAuth: true,
		includeInNavbar: false,
		includeInDropdown: true,
		hasBackNavigation: false,
		hideFor: helper.jkrRoles,
		title: 'Manage Budgets',
		icon: 'fa-solid fa-sack-dollar'
	}
}, {
	path: '*',
	name: 'PageNotFound',
	component: () => import('@/views/PageNotFound'),
	meta: {
		includeInNavbar: false,
		title: 'Page Not Found',
	}
}]